import menuIcon from '!!url-loader!./images/open.svg';
import { Component, OnInit, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { RootReducer, Store } from '@app/app.reducers';
import { openMobileMenu } from '@app/core/reducers/mobile-menu.reducer';
import { getLogoUrl, getMobileLogoUrl } from '@app/shared/reducers/storefront.reducer';
import { ViewportService } from '@app/shared/services/viewport.service';

@Component({
	selector: 'g-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
	standalone: false,
})
export class HeaderComponent {
	private readonly store = inject<Store<RootReducer.State>>(Store);
	private readonly sanitizer = inject(DomSanitizer);
	readonly viewport = inject(ViewportService);

	readonly logoUrl$ = this.store.select(getLogoUrl);
	readonly mobileLogoUrl$ = this.store.select(getMobileLogoUrl);
	menuIcon = this.sanitizer.bypassSecurityTrustUrl(menuIcon);

	openMobileMenu(): void {
		this.store.dispatch(openMobileMenu());
	}
}
